function f(r, t) {
  r = r.split("-"), t = t.split("-");
  for (var N = r[0].split("."), s = t[0].split("."), e = 0; e < 3; e++) {
    var i = Number(N[e]), u = Number(s[e]);
    if (i > u)
      return 1;
    if (u > i)
      return -1;
    if (!isNaN(i) && isNaN(u))
      return 1;
    if (isNaN(i) && !isNaN(u))
      return -1;
  }
  return r[1] && t[1] ? r[1] > t[1] ? 1 : r[1] < t[1] ? -1 : 0 : !r[1] && t[1] ? 1 : r[1] && !t[1] ? -1 : 0;
}
export {
  f as default
};
//# sourceMappingURL=semver-compare.mjs.map
